<template>
  <!-- 电桩管理 -->
  <div class="billOperationRecord public_Spacing bridge-page">
    <div class="bridge-hero">
      <div class="bridge-hero-main">
        <span class="bridge-eyebrow">CHARGING PILE</span>
        <h2>电桩管理</h2>
        <p>集中维护充电桩编号、站点归属、设备类型、费率版本与在线状态。</p>
      </div>
      <div class="bridge-hero-metrics">
        <div class="bridge-metric-card">
          <span>当前列表</span>
          <strong>{{ tableData.length || 0 }}</strong>
        </div>
        <div class="bridge-metric-card">
          <span>电桩总数</span>
          <strong>{{ pagingPageMo || 0 }}</strong>
        </div>
        <div class="bridge-metric-card bridge-metric-online">
          <span>在线总计</span>
          <strong>{{ zx || 0 }}</strong>
        </div>
        <div class="bridge-metric-card bridge-metric-offline">
          <span>离线总计</span>
          <strong>{{ lx || 0 }}</strong>
        </div>
      </div>
    </div>
    <div class="pulbic_oparetionBlock bridge-filter-card">
      <div class="bridge-section-head">
        <div>
          <strong>筛选电桩</strong>
          <span>按站点、设备名称、编号、类型和创建时间快速定位电桩</span>
        </div>
      </div>
      <el-form
        :inline="true"
        class="demo-form-inline bridge-filter-form"
        size="small"
        label-position="left"
      >
        <el-form-item label="归属站点" class="searchfrom_item">
          <el-select clearable v-model="ormtb601id" placeholder="请选择">
            <el-option
              v-for="item in ormtb601idList"
              :key="item.ormtb601id"
              :label="item.ormtb601ca00"
              :value="item.ormtb601id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称" class="searchfrom_item">
          <el-input v-model="ormtb602ca03" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设备编号" class="searchfrom_item">
          <el-input v-model="ormtb602ca00" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="电桩类型" class="searchfrom_item">
          <el-select v-model="ormtb602ca06" placeholder="请选择">
            <el-option label="直流" :value="1"> </el-option>
            <el-option label="交流" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" class="searchfrom_item bridge-date-item">
          <el-date-picker
            v-model="dateTime1"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="search_btns bridge-search-actions">
          <el-button
            size="medium"
            v-shiroHiden="solelist"
            type="primary"
            id="搜索"
            @click="queryClick"
            >搜索</el-button
          >
          <el-button
            size="medium"
            type="success"
            @click="serchReset"
            v-shiroHiden="solelist"
            id="搜索"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="billOperationRecord-table pulbic_table_container bridge-table-card">
      <div class="top_title bridge-table-head">
        <div>
          <div class="title">电桩列表</div>
          <div class="bridge-table-subtitle">查看电桩站点归属、设备规格、费率版本和维护操作</div>
        </div>
        <div class="right_btns bridge-table-actions">
          <span class="bridge-table-total">共 {{ pagingPageMo || 0 }} 条</span>
          <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            @click="cduserClick()"
            id="新增"
            v-shiroHiden="solelist"
            >新增</el-button
          >

          <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            @click="alldetClick()"
            id="删除"
            v-shiroHiden="solelist"
            >删除</el-button
          >
          <span class="bridge-status-pill bridge-online">在线 {{ zx || 0 }}</span>
          <span class="bridge-status-pill bridge-offline">离线 {{ lx || 0 }}</span>
        </div>
      </div>
      <el-table
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        :default-sort="{ prop: 'waterNum', order: 'descending' }"
        :header-cell-style="{
          color: 'rgba(255,255,255,1)',
          background: '#199FFF',
          'font-weight': 'bold',
        }"
        :header-cell-class-name="'custom-header'"
        class="public_tableColumn"
        @selection-change="handleSelectionChange"
      >
        <!--<el-table-column prop="ORMTB440CA00" width="130" fixed="left" label="派单编号">-->
        <!--</el-table-column>-->
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="ormtb602ca00"
          label="充电桩编号"
        ></el-table-column>
        <el-table-column
          prop="ormtb601ca00"
          label="归属站点"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tooltip
              class="custom_tooltip"
              effect="dark"
              :content="scope.row.ormtb601ca00"
              placement="top"
            >
              <p>
                <span class="name_length">{{ scope.row.ormtb601ca00 }}</span>
              </p>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column
          prop="ormtb602ca03"
          label="充电桩名称"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tooltip
              class="custom_tooltip"
              effect="dark"
              :content="scope.row.ormtb602ca03"
              placement="top"
            >
              <p>
                <span class="name_length">{{ scope.row.ormtb602ca03 }}</span>
              </p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb602ca04" label="功率(Kw)"></el-table-column>
        <el-table-column prop="ormtb602ca05" label="枪口数"></el-table-column>
        <el-table-column prop="ormtb602ca01" label="厂家">
          <template slot-scope="scope">
            <span>{{ scope.row.ormtb602ca01 == 'JS' ? '嘉盛' : '金冠' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb602ca06" label="充电类型">
          <template slot-scope="scope">
            <span>{{
              scope.row.ormtb602ca06 == '1' ? '直流设备' : '交流设备'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb608ca01" label="费率版本"></el-table-column>
        <el-table-column prop="ormtb602ca07" label="登记时间"></el-table-column>
        <!-- <el-table-column
          v-for="(item, index) in tableHeadList"
          :width="item.width"
          :prop="item.prop"
          :label="item.label"
          :key="index"
        >
        </el-table-column> -->

        <el-table-column
          v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'"
          label="操作"
          fixed="right"
          width="300"
        >
          <template slot-scope="scope">
            <el-button
              class="bridge-operate-btn public_icon_xiangqing public_icon_width  public_icon_margin"
              type="primary"
              size="small"
              id="详情"
              v-shiroHiden="solelist"
              @click="DetailsClick(scope.row)"
              >详情</el-button
            >
            <el-button
              @click="modify(scope.row)"
              class="bridge-operate-btn public_icon_xiugai public_icon_width  public_icon_margin"
              id="修改"
              type="primary"
              size="small"
              v-shiroHiden="solelist"
              >修改</el-button
            >
            <el-button
              @click="detBtn(scope.row)"
              class="bridge-operate-btn public_icon_zuofei public_icon_width  public_icon_margin"
              id="删除"
              type="primary"
              size="small"
              v-shiroHiden="solelist"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limitMo"
          layout="total,sizes, prev, pager, next, jumper"
          :total="pagingPageMo"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增表单-->
    <el-dialog
      width="800px"
      :title="paramFrom.ormtb602id ? '修改充电桩' : '添加充电桩'"
      :visible.sync="cdsUpdateShow"
     append-to-body custom-class="bridge-dialog">
      <el-divider></el-divider>
      <el-form
        :model="paramFrom"
        ref="paramFrom"
        size="small"
        label-position="right"
      >
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item
              prop="ormtb602ca03"
              :rules="{
                required: true,
                message: '设备名称不能为空',
                trigger: 'blur',
              }"
              label="设备名称"
              class="from_item"
            >
              <el-input
                v-model="paramFrom.ormtb602ca03"
                placeholder="请输入内容"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="归属站点"
              class="from_item"
              prop="ormtb601id"
              :rules="{
                required: true,
                message: '请选择归属站点',
                trigger: 'change',
              }"
            >
              <el-select
                v-model="paramFrom.ormtb601id"
                placeholder="请选择归属站点"
                style="width:100%"
                @change="zdChange"
              >
                <el-option
                  v-for="item in ormtb601idList"
                  :key="item.ormtb601id"
                  :label="item.ormtb601ca00"
                  :value="item.ormtb601id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item
              label="设备编码"
              class="from_item"
              prop="ormtb602ca00"
            >
              <el-input
                v-model="paramFrom.ormtb602ca00"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="电桩类型"
              class="from_item"
              prop="ormtb602ca06"
              :rules="{
                required: true,
                message: '请选择电桩类型',
                trigger: 'change',
              }"
            >
              <el-select
                v-model="paramFrom.ormtb602ca06"
                placeholder="请选择电桩类型"
                style="width:100%"
                @change="typeChange"
              >
                <el-option label="直流电" value="1"></el-option>
                <el-option label="交流电" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="12" v-show="paramFrom.ormtb601id">
            <el-form-item
              :rules="{
                required: true,
                message: '请选择计费规则',
                trigger: 'change',
              }"
              prop="ormtb608id"
              label="计费规则"
              class="from_item"
            >
              <el-select
                v-model="paramFrom.ormtb608id"
                placeholder="请选择计费规则"
                style="width:100%"
              >
                <el-option
                  v-for="item in ormtb608idList"
                  :key="item.ormtb608id"
                  :label="item.ormtb608ca01"
                  :value="item.ormtb608id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="厂家"
              class="from_item"
              prop="ormtb602ca01"
              :rules="{
                required: true,
                message: '请选择厂家',
                trigger: 'change',
              }"
            >
              <el-select
                v-model="paramFrom.ormtb602ca01"
                placeholder="请选择厂家"
                style="width:100%"
              >
                <el-option label="金冠" value="JG"></el-option>
                <el-option label="嘉盛" value="JS"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item
              label="总功率(Kw)"
              class="from_item"
              prop="ormtb602ca04"
              :rules="{
                required: true,
                message: '请选择总功率',
                trigger: 'change',
              }"
            >
              <el-input-number
                v-model="paramFrom.ormtb602ca04"
                style="width:100%"
                label="请选择功率"
                :step="100"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="枪口数"
              class="from_item"
              prop="ormtb602ca05"
              :rules="{
                required: true,
                message: '请选择枪口数',
                trigger: 'change',
              }"
            >
              <el-input-number
                v-model="paramFrom.ormtb602ca05"
                label="请选择枪口数"
                style="width:100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item
              label="最大电流"
              class="from_item"
              prop="ormtb602ca09"
            >
              <el-input-number
                v-model="paramFrom.ormtb602ca09"
                style="width:100%"
                label="请输入最大电流"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-form-item label="备注" class="from_item" prop="ormtb602ca10">
            <el-input
              style="width:97%"
              type="textarea"
              placeholder="请输入内容"
              v-model="paramFrom.ormtb602ca10"
              maxlength="50"
              :rows="5"
              v-no-emoji
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item class="sub_btns">
            <el-button @click="cdsUpdateShow = false">取 消</el-button>
            <el-button type="primary" @click="preservationAdd('paramFrom')"
              >确 定</el-button
            >
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    Map,
  },
  data() {
    return {
      ormtb601id: '',
      ormtb602ca00: '',
      ormtb602ca03: '',
      ormtb602ca06: '',
      startTime: '',
      endTime: '',
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      ormtb601idList: [],
      dateTime1: [],
      lx: '',
      zx: '',
      paramFrom: {
        ormtb601id: '',
        ormtb602ca00: '',
        ormtb602ca0: '',
        ormtb602ca03: '',
        ormtb602ca04: 100,
        ormtb602ca05: 1,
        ormtb602ca06: '',
        ormtb608id: '',
        ormtb602ca09: 1,
        ormtb602ca10: '',
      },
      tableData: [],
      ormtb608idList: [], //费率列表
      cdsUpdateShow: false,
      uobj: this.$store.state.uobj, //登陆缓存--用户信息

      //dialog

      pagingPageMo: 0, //分页--数据列表共有的条数
      currentPage: 1, //设置当前页默认为1
      // 详情
      detailsList: '', //详情列表
      userobj: undefined,

      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',
      solelist: [], //权限列表
    }
  },
  // 存储数据
  beforeDestroy() {
    var obj = {
      ormtb601id: this.ormtb601id,
      ormtb602ca00: this.ormtb602ca00,
      ormtb602ca03: this.ormtb602ca03,
      ormtb602ca06: this.ormtb602ca06,
      startTime: this.dateTime1[0],
      endTime: this.dateTime1[1],
      pageMo: this.pageMo,
      limitMo: this.limitMo,
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },

  // watch: {
  //   weightOpt: {
  //     handler(val) {
  //       if (
  //         (val.tare || val.tare === 0) &&
  //         (val.gross || val.gross === 0) &&
  //         (val.price || val.price === 0)
  //       ) {
  //         let tare = parseFloat(val.tare);
  //         let gross = parseFloat(val.gross);
  //         this.detailsList.ORMTB440CC04 = (tare - gross).toFixed(2);
  //         if (this.detailsList.ORMTB440CC04) {
  //           debounce(this.getSettlementAmount, 500);
  //         }
  //       } else {
  //         this.detailsList.ORMTB440CC04 = "";
  //         this.detailsList.ORMTB440CC06 = "";
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  created() {
    var list = ''
    list = this.$store.state.solelist
    var path = this.$route.path
    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))

    this.userobj = this.$store.state.uobj
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表

    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    }
    this.getormtb601idList()
    // console.log(this.historyInfo)
    // else {
    // 	this.getNowDay();
    // }
  },
  mounted() {
    this.getonlineList()
    this.pageList()
  },
  computed: {},
  methods: {
    //查询

    //重置
    serchReset() {
      this.ormtb601id = ''
      this.ormtb602ca00 = ''
      this.ormtb602ca03 = ''
      this.ormtb602ca06 = ''
      this.startTime = ''
      this.endTime = ''
      this.dateTime1 = []
      this.pageMo = 1
      this.pageList()
    },
    typeChange(val) {
      console.log('val', val)
    },

    //获取站点
    getormtb601idList() {
      var url = '/orm/ormtb601/selecAll601'
      this.axios.post(url).then(res => {
        if (res.data.code == 200) {
          this.ormtb601idList = res.data.data
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    //在线离线统计
    getonlineList() {
      var url = '/orm/ormtb602/select602Count'
      let obj = {
        ormtb601id: this.ormtb601id,
        ormtb602ca00: this.ormtb602ca00,
        ormtb602ca03: this.ormtb602ca03,
        ormtb602ca06: this.ormtb602ca06,
        startTime: this.dateTime1[0],
        endTime: this.dateTime1[1],
        pageMo: this.pageMo,
        limitMo: this.limitMo,
      }
      this.axios
        .post(url, obj)
        .then(res => {
          if (res.data.code == 200) {
            this.zx = res.data.data.zx
            this.lx = res.data.data.lx
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
    //费率列表
    getormtb608idList(val) {
      var url = '/orm/ormtb608/select608List'
      let data = {
        ormtb601id: val,
      }
      this.axios.post(url, data).then(res => {
        if (res.data.code == 200) {
          this.ormtb608idList = res.data.data
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    handleSelectionChange(val) {
      this.detIds = val
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = val
      this.pageList()
    },

    //初始化数据
    init() {
      this.ormtb601id = this.historyInfo.ormtb601id
      this.ormtb602ca00 = this.historyInfo.ormtb602ca00
      this.ormtb602ca03 = this.historyInfo.ormtb602ca03
      this.ormtb602ca06 = this.historyInfo.ormtb602ca06
      this.startTime = this.historyInfo.startTime
      this.endTime = this.historyInfo.endTime
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
    },

    // 新增提交
    preservationAdd(formName) {
      let $this = this
      let url = !$this.paramFrom.ormtb602id
        ? 'orm/ormtb602/add'
        : 'orm/ormtb602/update'
      this.$refs[formName].validate(valid => {
        if (valid) {
          var loading = this.$loading({
            lock: true,
            text: '请求中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)',
          })
          let postData = $this.paramFrom

          $this.axios
            .post(url, postData)
            .then(res => {
              if (res.data.code == 200) {
                $this.$message({
                  message: !$this.paramFrom.ormtb602id
                    ? '新增成功'
                    : '修改成功',
                  type: 'success',
                })
                $this.$refs[formName].resetFields()
                $this.pageList()
                $this.cdsUpdateShow = false
              } else {
                $this.$message({
                  message: res.data.message,
                  type: 'error',
                })
              }
              setTimeout(() => {
                loading.close()
              }, 300)
            })
            .catch(() => {
              loading.close()
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //单个删除
    detBtn(row) {
      const $this = this
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          if (!row.ormtb602id) {
            $this.$message.error('数据异常,无法删除')
            return
          }

          try {
            const res = await $this.axios.post('orm/ormtb602/delete', {
              ormtb602ids: row.ormtb602id,
            })

            if (res.data.code === 200) {
              $this.$message.success('删除成功')
              $this.pageList()
            } else {
              $this.$message.error(res.data.message || '删除失败')
            }
          } catch (error) {
            console.error('删除请求失败:', error)
            $this.$message.error('删除请求失败')
          }
        })
        .catch(() => {
          $this.$message.info('已取消删除')
        })
    },
    //多个删除
    alldetClick() {
      const $this = this
      if (!this.detIds.length) {
        return $this.$message.warning('请选择数据')
      }
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let ids = this.detIds.map(e => e.ormtb602id).toString()
          if (!ids) {
            $this.$message.error('数据异常,无法删除')
            return
          }

          try {
            const res = await $this.axios.post('orm/ormtb602/delete', {
              ormtb602ids: ids,
            })
            if (res.data.code === 200) {
              $this.$message.success('删除成功')
              $this.pageList()
            } else {
              $this.$message.error(res.data.message || '删除失败')
            }
          } catch (error) {
            console.error('删除请求失败:', error)
            $this.$message.error('删除请求失败')
          }
        })
        .catch(() => {
          $this.$message.info('已取消删除')
        })
    },

    // 查询
    queryClick() {
      this.pageMo = 1
      this.tableData = []
      this.pageList()
    },
    // 列表
    pageList() {
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        // startTime: this.startTime, //开始时间
        // endTime: this.endTime, //结束时间
        // ORMTB473CA00: this.ORMTB473CA00,
        page: this.pageMo,
        limit: this.limitMo,
        ormtb601id: this.ormtb601id,
        ormtb602ca00: this.ormtb602ca00,
        ormtb602ca03: this.ormtb602ca03,
        ormtb602ca06: this.ormtb602ca06,
        startTime: this.dateTime1[0],
        endTime: this.dateTime1[1],
      }

      var url = '/orm/ormtb602/select602Page'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)

          if (res.data.code == 200) {
            var data = res.data.data
            this.pagingPageMo = res.data.count
            this.tableData = data
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    zdChange(val) {
      // console.log('站点Id', val)
      // this.paramFrom.ormtb608id = ''
      this.getormtb608idList(val)
      if (this.paramFrom.ormtb601id) {
        this.$set(this.paramFrom, 'ormtb608id', '')
      }
    },
    // 详情
    DetailsClick(row) {
      debugger
      let tabList = this.$store.state.tablist
      const tabIndex = tabList.findIndex(
        item => item.PERTB001CA05 === 'Home:bridgeDetails'
      )
      if (tabIndex !== -1) {
        tabList.splice(tabIndex, 1) //移除已存在电桩详情
      }
      let path = `/Home/bridgeDetails?id=${row.ormtb602id}`
      let resitem = {
        PERTB001CA00: '电桩详情',
        PERTB001CA03: `${path}`,
        PERTB001CA04: '1',
        PERTB001CA05: 'Home:bridgeDetails',
        PERTB001CB00: 'ALL',
      }

      var str = JSON.stringify(tabList)
      var index = str.indexOf('/Home/bridgeDetails')
      if (index == -1) {
        var Stablsit = this.$store.state.tablist.slice()
        Stablsit.push(resitem)
        this.$store.commit('upEditableTabs', Stablsit)
      }
      this.$store.commit('setHistTabsValue', path)
      this.$router.push(this.$store.state.setHistTabsValue)
      // this.$router
      //   .push({
      //     name: 'bridgeDetails',
      //     query: {
      //       ormtb602id: JSON.stringify(row),
      //     },
      //   })
      //   .catch(err => {
      //     console.error('路由跳转错误:', err)

      //   })
    },

    async modify(row) {
      await this.getormtb608idList(row.ormtb601id)
      this.paramFrom = JSON.parse(JSON.stringify(row))
      this.paramFrom.ormtb608id = String(this.paramFrom.ormtb608id)
      this.cdsUpdateShow = true
    },

    cduserClick(row) {
      this.cdsUpdateShow = true
      this.paramFrom = {
        ormtb601id: '',
        ormtb602ca00: '',
        ormtb602ca0: '',
        ormtb602ca03: '',
        ormtb602ca04: 100,
        ormtb602ca05: 1,
        ormtb602ca06: '',
        ormtb602ca09: 1,
        ormtb602ca10: '',
      }
    },

    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.pageList()
    },
  },
}
</script>

<style scoped>
.top_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
  padding: 4px 0 8px;
}
.title {
  position: relative;
  padding-left: 12px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #183b5b;
}
.title::before {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 0;
  width: 4px;
  border-radius: 4px;
  content: '';
  background: #199fff;
}
.right_btns button {
  margin-left: 18px;
}

.from_item {
  display: flex;
}
::v-deep .from_item .el-form-item__label {
  width: 120px !important;
}
::v-deep .searchfrom_item .el-form-item__label {
  width: 100px !important;
  margin-left: 20px;
}
::v-deep .searchfrom_item .el-form-item__content {
  width: 60%;
}
::v-deep .from_item .el-form-item__content {
  width: 90%;
}
::v-deep .el-table .has-gutter tr {
  background: #199fff !important;
}

::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper th,
::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper tr,
::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper .el-table__cell {
  color: #fff !important;
  background: #199fff !important;
  font-weight: bold;
}

::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper .cell {
  color: #fff !important;
}

::v-deep .bridge-operate-btn.public_icon_xiangqing {
  color: #fff !important;
  background: #199fff !important;
}

::v-deep .bridge-operate-btn.public_icon_xiugai {
  color: #fff !important;
  background: #e59c00 !important;
}

::v-deep .bridge-operate-btn.public_icon_zuofei {
  color: #fff !important;
  background: #ff5a45 !important;
}

::v-deep .bridge-operate-btn:hover {
  opacity: .86;
}

::v-deep .el-dialog__body {
  padding-top: 3px;
}
::v-deep .el-divider--horizontal {
  margin-top: 10px;
}
.pulbic_oparetionBlock {
  text-align: left;
}
.search_btns {
  float: right;
}
.sub_btns {
  float: right;
  margin-top: 20px;
}
</style>

<style>
.bridge-page {
  padding: 18px;
  background: transparent;
  color: #25384d;
}

.bridge-hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  margin-bottom: 16px;
  padding: 20px 22px;
  border: 1px solid rgba(188, 222, 236, 0.95);
  border-radius: 18px;
  background: linear-gradient(135deg, #ffffff 0%, #f2fbff 54%, #eef8f4 100%);
  box-shadow: 0 12px 32px rgba(26, 99, 134, 0.08);
  box-sizing: border-box;
}

.bridge-hero-main {
  min-width: 0;
}

.bridge-eyebrow {
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(25, 159, 255, 0.12);
  color: #1473b3;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.bridge-hero h2 {
  margin: 0;
  color: #17324d;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 1px;
}

.bridge-hero p {
  margin: 8px 0 0;
  color: #60758a;
  font-size: 13px;
  line-height: 1.6;
}

.bridge-hero-metrics {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
}

.bridge-metric-card {
  min-width: 102px;
  padding: 13px 14px;
  border: 1px solid rgba(203, 226, 236, 0.92);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 8px 20px rgba(26, 99, 134, 0.08);
  text-align: center;
  box-sizing: border-box;
}

.bridge-metric-card span {
  display: block;
  color: #6d8194;
  font-size: 12px;
}

.bridge-metric-card strong {
  display: block;
  margin-top: 6px;
  color: #1473b3;
  font-size: 22px;
  line-height: 1;
}

.bridge-metric-online strong {
  color: #0e9f6e;
}

.bridge-metric-offline strong {
  color: #6b7280;
}

.bridge-filter-card,
.bridge-table-card {
  border: 1px solid rgba(216, 232, 238, 0.96);
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 10px 26px rgba(26, 99, 134, 0.07);
  box-sizing: border-box;
}

.bridge-filter-card {
  margin-bottom: 16px !important;
  padding: 16px 18px;
}

.bridge-section-head,
.bridge-table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.bridge-section-head strong,
.bridge-table-head .title {
  display: block;
  color: #17324d;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
}

.bridge-section-head span,
.bridge-table-subtitle {
  display: block;
  margin-top: 4px;
  color: #6b7e90;
  font-size: 12px;
}

.bridge-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 18px;
}

.bridge-filter-form .el-form-item {
  display: flex;
  align-items: center;
  margin: 0;
}

.bridge-page .searchfrom_item .el-form-item__label,
.bridge-page .searchfrom_item .el-form-item__content {
  width: auto !important;
  margin-left: 0 !important;
}

.bridge-page .searchfrom_item .el-form-item__label {
  padding-right: 10px;
  color: #60758a;
  font-weight: 700;
}

.bridge-page .searchfrom_item .el-select,
.bridge-page .searchfrom_item .el-input {
  width: 210px;
}

.bridge-page .bridge-date-item .el-date-editor {
  width: 360px;
}

.bridge-page .el-input__inner,
.bridge-page .el-textarea__inner {
  border-color: rgba(197, 216, 226, 0.95);
  border-radius: 9px;
  background: #f8fcff;
}

.bridge-search-actions {
  float: none;
}

.bridge-search-actions .el-form-item__content {
  display: flex;
  gap: 12px;
}

.bridge-search-actions .el-button {
  min-width: 70px;
  border-radius: 9px;
  font-weight: 700;
  box-shadow: 0 8px 16px rgba(25, 115, 179, 0.12);
}

.bridge-search-actions .el-button--success {
  border-color: #d97706;
  background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
  color: #fff;
}

.bridge-table-card {
  padding: 18px !important;
}

.bridge-table-head {
  padding-top: 6px;
  padding-left: 6px;
}

.bridge-table-head .title {
  padding-left: 12px;
  line-height: 24px;
}

.bridge-table-head .title::before {
  top: 4px;
  bottom: 4px;
  background: #199fff;
}

.bridge-table-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.bridge-table-actions button,
.bridge-table-actions .el-button {
  margin-left: 0 !important;
  border-radius: 9px;
  font-weight: 700;
}

.bridge-table-total,
.bridge-status-pill {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
}

.bridge-table-total {
  background: #eef8ff;
  color: #1473b3;
}

.bridge-online {
  background: #ebfbf4;
  color: #0e9f6e;
}

.bridge-offline {
  background: #f3f4f6;
  color: #6b7280;
}

.bridge-table-card .el-table {
  border-radius: 12px;
  overflow: hidden;
}

.bridge-table-card .el-table .has-gutter tr,
.bridge-table-card .el-table th,
.bridge-table-card .el-table__fixed-right .el-table__fixed-header-wrapper th,
.bridge-table-card .el-table__fixed-right .el-table__fixed-header-wrapper tr,
.bridge-table-card .el-table__fixed-right .el-table__fixed-header-wrapper .el-table__cell {
  background: linear-gradient(180deg, #4aaee8 0%, #199fff 100%) !important;
  color: #fff !important;
}

.bridge-table-card .el-table td {
  color: #33485c;
}

.bridge-dialog {
  border: 1px solid rgba(188, 222, 236, 0.95);
  border-radius: 18px;
  background: #f8fcff;
  box-shadow: 0 24px 70px rgba(20, 78, 112, 0.20);
  overflow: hidden;
}

.bridge-dialog .el-dialog__header {
  position: relative;
  padding: 20px 24px 18px 54px;
  background: linear-gradient(135deg, #f2fbff 0%, #eaf7ff 100%);
  border-bottom: 1px solid rgba(216, 232, 238, 0.95);
}

.bridge-dialog .el-dialog__header::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 22px;
  width: 18px;
  height: 18px;
  border: 5px solid rgba(25, 159, 255, 0.18);
  border-radius: 50%;
  background: #199fff;
  box-sizing: border-box;
  transform: translateY(-50%);
}

.bridge-dialog .el-dialog__title {
  color: #17324d;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 1px;
}

.bridge-dialog .el-dialog__body {
  padding: 24px !important;
  background: linear-gradient(180deg, #f8fcff 0%, #f4faff 100%);
}

.bridge-dialog .el-divider {
  display: none;
}

.bridge-dialog .el-form {
  position: relative;
  padding: 54px 20px 0;
  border: 1px solid rgba(216, 232, 238, 0.96);
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 10px 24px rgba(26, 99, 134, 0.07);
  box-sizing: border-box;
}

.bridge-dialog .el-form::before {
  content: '电桩信息';
  position: absolute;
  top: 16px;
  left: 18px;
  padding-left: 12px;
  color: #17324d;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 20px;
}

.bridge-dialog .el-form::after {
  content: '';
  position: absolute;
  top: 19px;
  left: 18px;
  width: 4px;
  height: 14px;
  border-radius: 999px;
  background: linear-gradient(180deg, #4aaee8 0%, #199fff 100%);
}

.bridge-dialog .el-form .el-row {
  margin-bottom: 26px;
}

.bridge-dialog .el-form .el-row:last-child {
  margin-bottom: 0;
}

.bridge-dialog .from_item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0;
}

.bridge-dialog .from_item .el-form-item__label {
  width: 116px !important;
  padding-right: 12px;
  color: #60758a;
  font-weight: 700;
  line-height: 34px;
}

.bridge-dialog .from_item .el-form-item__content {
  flex: 1;
  width: auto !important;
}

.bridge-dialog .el-input-number,
.bridge-dialog .el-select,
.bridge-dialog .el-input,
.bridge-dialog .el-textarea {
  width: 100% !important;
}

.bridge-dialog .el-input__inner,
.bridge-dialog .el-textarea__inner {
  border-color: rgba(197, 216, 226, 0.95);
  border-radius: 10px;
  background: #fff;
  color: #25384d;
  transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

.bridge-dialog .el-input__inner:focus,
.bridge-dialog .el-textarea__inner:focus {
  border-color: #199fff;
  background: #fbfdff;
  box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
}

.bridge-dialog .el-input-number .el-input__inner {
  text-align: left;
}

.bridge-dialog .el-textarea__inner {
  min-height: 116px !important;
  line-height: 1.7;
  resize: vertical;
}

.bridge-dialog .sub_btns {
  float: none;
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin: 10px -20px 0;
  padding: 24px 20px 18px;
  border-top: 1px solid rgba(216, 232, 238, 0.95);
  background: linear-gradient(180deg, rgba(248, 252, 255, 0.35) 0%, #ffffff 100%);
}

.bridge-dialog .sub_btns .el-form-item__content {
  display: flex;
  gap: 24px;
  margin-left: auto !important;
}

.bridge-dialog .sub_btns .el-button {
  min-width: 96px;
  height: 36px;
  border-radius: 10px;
  font-weight: 700;
}

.bridge-dialog .sub_btns .el-button--primary {
  border-color: #199fff;
  background: linear-gradient(180deg, #4aaee8 0%, #199fff 100%);
  box-shadow: 0 8px 18px rgba(25, 159, 255, 0.22);
}

@media screen and (max-width: 1100px) {
  .bridge-hero {
    align-items: stretch;
    flex-direction: column;
  }

  .bridge-hero-metrics {
    justify-content: flex-start;
    width: 100%;
  }

  .bridge-table-head {
    align-items: flex-start;
    flex-direction: column;
  }

  .bridge-page .bridge-date-item .el-date-editor {
    width: 100%;
  }
}
</style>
